// node modules
import React from 'react';
import PropTypes from 'prop-types';
import { RefinementListFilter, SearchkitComponent } from 'searchkit';

// app modules: components
import PanelOuterClick from 'components/PanelOuterClick';

class SearchkitDropdown extends SearchkitComponent {
  constructor(props) {
    super(props);
    this.clear = this.clear.bind(this);
    this.state = {};
  }

  static propTypes = {
    stateKey: PropTypes.string.isRequired,
    visibleWhenUnselected: PropTypes.bool,
    hidden: PropTypes.bool,
  };

  static defaultProps = {
    visibleWhenUnselected: true,
    hidden: false,
  };

  getAccessor() {
    const { stateKey } = this.props;
    return this.searchkit.accessors.statefulAccessors[stateKey] || null;
  }

  clear(event) {
    event.stopPropagation();
    const acc = this.getAccessor();
    if (acc && acc.state.clear) {
      acc.state = acc.state.clear();
      this.searchkit.performSearch();
    }
    this.setState(this.state);
  }

  renderFilterElement(visible) {
    const { title, stateKey } = this.props;
    const searchKitState = this.searchkit.state[stateKey] || [];
    const hasSelection = !!searchKitState.length;
    return (
      <RefinementListFilter
        {...this.props}
        title={searchKitState.length ? searchKitState.join(', ') : title}
        containerComponent={
          visible ? (
            <PanelOuterClick
              collapsable
              defaultCollapsed
              hasSelection={hasSelection}
              clear={this.clear}
            />
          ) : (
            <div hidden />
          )
        }
      />
    );
  }

  filterIsSelected() {
    if (this.getAccessor() !== null) {
      return !(
        this.getAccessor().resultsState.value === null ||
        this.getAccessor().resultsState.value.length === 0
      );
    }
    return false;
  }

  render() {
    const { visibleWhenUnselected, hidden } = this.props;

    const visible = !hidden && (visibleWhenUnselected || this.filterIsSelected());
    return this.renderFilterElement(visible);
  }
}

export default SearchkitDropdown;
